module.exports = __webpack_public_path__ + "i18n/translation.dd1771c7.json";